import { Chip } from '@/app/components/Chip'
import { useCourseCategoryImage } from '@/app/hooks/useCourseCategoryImage'
import { ICourse } from '@/types/course'

import React, { memo } from 'react'
import { ImageWithFallback } from '../../shared/components/image-with-fallback'

type CourseBannerProps = {
  courseInfo: Pick<
    ICourse,
    '_id' | 'categories' | 'educationProvider' | 'imageUrl'
  >
  aspectRatio?: 'top-course-banner' | 'course-card'
} & React.HTMLAttributes<HTMLDivElement>

function CourseBanner({
  courseInfo,
  aspectRatio = 'course-card',
  ...props
}: CourseBannerProps) {
  const { categoryImage } = useCourseCategoryImage(courseInfo)

  return courseInfo.imageUrl || categoryImage?.src ? (
    <div {...props} className={`relative ${props.className ?? ''}`}>
      {!!courseInfo?.categories?.[0]?.name && (
        <Chip
          className="absolute right-6 top-6 bg-mydra-yellow px-2 py-1 font-sans"
          size="medium"
        >
          {courseInfo.categories?.[0]?.name}
        </Chip>
      )}
      <div className="absolute inset-0 bg-enrolment-card-bg mix-blend-multiply" />
      <ImageWithFallback
        src={courseInfo.imageUrl ?? categoryImage?.src}
        fallbackSrc={categoryImage?.src}
        width={categoryImage?.width}
        height={categoryImage?.height}
        alt={courseInfo.categories?.[0]?.name ?? ''}
        className={`w-full object-cover ${aspectRatio === 'top-course-banner' ? 'aspect-top-course-banner' : 'aspect-course-card'}`}
      />

      <div className="absolute bottom-6 left-6 flex items-center gap-3">
        {courseInfo?.educationProvider?.logoUrl && (
          <ImageWithFallback
            src={courseInfo?.educationProvider?.logoUrl}
            alt={`${courseInfo?.educationProvider?.name} logo`}
            width={40}
            height={40}
            className="h-14 w-14 rounded-full"
          />
        )}
        <p className="font-medium text-white">
          {courseInfo.educationProvider?.name ?? ''}
        </p>
      </div>
    </div>
  ) : null
}

const MemoizedCourseBanner = memo(CourseBanner)

export { MemoizedCourseBanner as CourseBanner }
